module.exports = __webpack_public_path__ + "static/cs-apple-e2ba5c66e84e640cd67071533d3cd941.png";